/**
 * Businesses Feature API
 */

import apiClient from '../../../shared/services/apiClient';

export const businessesAPI = {
  getAll: () => apiClient.get('/businesses'),
  getById: (id) => apiClient.get(`/businesses/${id}`),
  getChildren: (businessId) => apiClient.get(`/businesses/${businessId}/children`),
  getComplianceCalendar: (businessId) => apiClient.get(`/businesses/${businessId}/compliance/calendar`),
  listFormationDocuments: (businessId) => apiClient.get(`/businesses/${businessId}/formation-documents`),
  openFormationDocument: (businessId, documentKind) => apiClient.get(
    `/businesses/${businessId}/formation-documents/${documentKind}/file`,
    { responseType: 'blob' }
  ),
  saveFormationDocument: (businessId, documentKind, documentDate, file) => {
    const formData = new FormData();
    formData.append('document_kind', documentKind);
    formData.append('document_date', documentDate);
    formData.append('file', file);
    return apiClient.post(`/businesses/${businessId}/formation-documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  getSetupQuestions: () => apiClient.get('/businesses/setup-checklist/questions'),
  getSetupChecklist: (businessId) => apiClient.get(`/businesses/${businessId}/setup-checklist`),
  saveSetupAnswers: (businessId, answers) => apiClient.put(`/businesses/${businessId}/setup-checklist/answers`, { answers }),
  setSetupItem: (businessId, key, checked) => apiClient.put(`/businesses/${businessId}/setup-checklist/items/${encodeURIComponent(key)}`, { checked }),
  setSetupDismissed: (businessId, dismissed) => apiClient.put(`/businesses/${businessId}/setup-checklist/dismissed`, { dismissed }),
  getBranding: (businessId) => apiClient.get(`/businesses/${businessId}/branding`),
  saveBranding: (businessId, data) => apiClient.post(`/businesses/${businessId}/branding`, data),
  uploadLogo: (businessId, file) => {
    const formData = new FormData();
    formData.append('logo', file);
    return apiClient.post(`/businesses/${businessId}/branding/logo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  deleteLogo: (businessId) => apiClient.delete(`/businesses/${businessId}/branding/logo`),
  getSummary: (businessId) => apiClient.get(`/businesses/${businessId}/summary`),
  getFinancialRollup: (businessId, params) => apiClient.get(`/businesses/${businessId}/financials/rollup`, { params }),
  create: (data) => apiClient.post('/businesses', data),
  sampleStatus: (id) => apiClient.get(`/businesses/${id}/sample`),
  clearSample: (id) => apiClient.post(`/businesses/${id}/sample/clear`),
  update: (id, data) => apiClient.put(`/businesses/${id}`, data),
  delete: (id) => apiClient.delete(`/businesses/${id}`),
  
  // State registrations
  getStateRegistrations: (businessId) => apiClient.get(`/businesses/${businessId}/state-registrations`),
  createStateRegistration: (businessId, data) => apiClient.post(`/businesses/${businessId}/state-registrations`, data),
  updateStateRegistration: (businessId, id, data) => apiClient.put(`/businesses/${businessId}/state-registrations/${id}`, data),
  deleteStateRegistration: (businessId, id) => apiClient.delete(`/businesses/${businessId}/state-registrations/${id}`),
  
  // Registered agents
  getRegisteredAgents: (businessId) => apiClient.get(`/businesses/${businessId}/registered-agents`),
  createRegisteredAgent: (businessId, data) => apiClient.post(`/businesses/${businessId}/registered-agents`, data),
  updateRegisteredAgent: (businessId, id, data) => apiClient.put(`/businesses/${businessId}/registered-agents/${id}`, data),
  deleteRegisteredAgent: (businessId, id) => apiClient.delete(`/businesses/${businessId}/registered-agents/${id}`),
};

export default businessesAPI;

